import { createFileRoute } from "@tanstack/react-router";

import LogsPage from "@/components/pages/LogsPage";
import { FeatureGate } from "@/components/shared/FeatureGate";
import { FEATURES } from "@/lib/features";

export const Route = createFileRoute("/_authenticated/logs/")({
  component: LogsRoute,
});

function LogsRoute() {
  return (
    <FeatureGate feature={FEATURES.MONITORING} featureName="Monitoring">
      <LogsPage />
    </FeatureGate>
  );
}
